/**
 *
 * ChangeRoleDialog reducer
 *
 */

import { Map } from 'immutable';

import { OPEN_CHANGE_ROLE_DIALOG, CLOSE_CHANGE_ROLE_DIALOG } from './constants';

const initialState = new Map({
  open: false,
});

function changeRoleDialogReducer(state = initialState, { type }) {
  switch (type) {
    case OPEN_CHANGE_ROLE_DIALOG:
      return state
        .set('open', true);

    case CLOSE_CHANGE_ROLE_DIALOG:
      return state
        .set('open', false);

    default:
      return state;
  }
}


export default changeRoleDialogReducer;
